import { render } from "./ServiceSearchbox.vue?vue&type=template&id=47d25ba8"
import script from "./ServiceSearchbox.vue?vue&type=script&lang=js"
export * from "./ServiceSearchbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__